/* Provencelia, 29/09/2026 : section avis Judge.me « Ils en parlent », une rangée qui défile.
   Judge.me dessine son widget après le chargement (et le redessine à chaque page d'avis) :
   on attend qu'il soit là, on renomme le titre et on ajoute deux flèches qui font défiler la
   liste. Styles : assets/pv-complements.css (#judgeme_product_reviews, .pv-avis-fleches).
   Chargé par snippets/pv-note-avis. */
(function () {
  'use strict';

  var TITRES = {
    fr: 'Ils en parlent', en: 'What our customers say', es: 'Lo que dicen nuestros clientes',
    it: 'Dicono di noi', de: 'Das sagen unsere Kunden', nl: 'Wat onze klanten zeggen',
    pl: 'Opinie naszych klientów', cs: 'Co říkají naši zákazníci', sk: 'Čo hovoria naši zákazníci',
    pt: 'O que dizem os nossos clientes'
  };
  var langue = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
  var FLECHE = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 3 5 8l5 5"/></svg>';

  function habiller(widget) {
    var titre = widget.querySelector('.jm-review-widget-minimal-header__title');
    if (titre && titre.dataset.pv !== '1') {
      titre.textContent = TITRES[langue] || TITRES.fr;
      titre.dataset.pv = '1';
    }

    var liste = widget.querySelector('.jdgm-review-list');
    var zone = widget.querySelector('.jm-review-widget-minimal-header__button-and-filters');
    if (!liste || !zone) return;

    var fleches = widget.querySelector('.pv-avis-fleches');
    if (!fleches) {
      fleches = document.createElement('div');
      fleches.className = 'pv-avis-fleches';
      fleches.innerHTML =
        '<button type="button" data-sens="-1" aria-label="Avis précédents">' + FLECHE + '</button>' +
        '<button type="button" data-sens="1" aria-label="Avis suivants" style="transform:scaleX(-1)">' + FLECHE + '</button>';
      zone.appendChild(fleches);
      fleches.addEventListener('click', function (e) {
        var b = e.target.closest('button');
        var l = widget.querySelector('.jdgm-review-list');
        if (!b || !l) return;
        var carte = l.firstElementChild;
        var pas = carte ? carte.getBoundingClientRect().width + 16 : l.clientWidth;
        l.scrollBy({ left: pas * parseInt(b.dataset.sens, 10), behavior: 'smooth' });
      });
    }

    var maj = function () {
      var l = widget.querySelector('.jdgm-review-list');
      if (!l) return;
      var btns = fleches.querySelectorAll('button');
      btns[0].disabled = l.scrollLeft <= 2;
      btns[1].disabled = l.scrollLeft + l.clientWidth >= l.scrollWidth - 2;
      fleches.style.display = l.scrollWidth > l.clientWidth + 2 ? '' : 'none';
    };
    if (liste.dataset.pv !== '1') {
      liste.dataset.pv = '1';
      liste.addEventListener('scroll', maj, { passive: true });
      window.addEventListener('resize', maj);
    }
    maj();
  }

  function lancer() {
    var widget = document.getElementById('judgeme_product_reviews');
    if (!widget) return;
    habiller(widget);
    var minuteur = null;
    new MutationObserver(function () {
      clearTimeout(minuteur);
      minuteur = setTimeout(function () { habiller(widget); }, 60);
    }).observe(widget, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lancer);
  } else {
    lancer();
  }
})();
